'use strict';

var _ = require('lodash');
var SponsorshipFlightPanelController = function SponsorshipFlightPanelController($scope) {
  $scope.uniqueId = 'sponsor-flight-chart-' + Math.random().toString().substr(2);
  function setSponsorList() {
    var flightMode = $scope.scheduleChange.significantManagedEntities.length === 0;
    var sponsors = [$scope.leg.sponsor, flightMode && $scope.leg];
    $scope.sponsorList = _.chain(sponsors).compact().map(function (sponsor, index) {
      var leg = sponsor.origin + '-' + sponsor.destination;
      sponsor.id = index + '-' + leg.toLowerCase();
      sponsor.label = leg;
      return sponsor;
    }).value();
  }
  setSponsorList();
  function setDefaults() {
    var flightSponsor = $scope.leg.flightSponsor;
    if (flightSponsor) {
      $scope.isUnderReview = true;
      $scope.sponsor = flightSponsor;
      $scope.selectedFlightSummary = flightSponsor.flightSummary;
      $scope.sponsor.selected = _.find($scope.sponsorList, {
        origin: flightSponsor.selected.origin,
        destination: flightSponsor.selected.destination
      });
    } else {
      $scope.isUnderReview = false;
      $scope.selectedFlightSummary = '';
      $scope.sponsor = {
        flightSummary: '',
        sourceBusinessId: '',
        businessId: '',
        selected: {}
      };
    }
  }
  setDefaults();
  $scope.isAlreadySponsored = function () {
    return $scope.hasSourceBusinessId() && !$scope.isValidSourceBusinessId();
  };
  $scope.isSourceBusinessNotTaken = function () {
    return !_.chain($scope.scheduleChange.managedEntities).filter(function (entity) {
      return entity !== $scope.leg;
    }).filter(['leg', $scope.leg.leg]).some(['flightSponsor.sourceBusinessId', $scope.sponsor.sourceBusinessId]).value();
  };
  $scope.isValidSourceBusinessId = function () {
    return $scope.hasSourceBusinessId() && $scope.isSourceBusinessNotTaken();
  };
  $scope.resetBusinessId = function () {
    $scope.sponsor.sourceBusinessId = '';
  };
  $scope.hasSourceBusinessId = function () {
    return !_.isEmpty($scope.sponsor.sourceBusinessId);
  };
  $scope.hasSponsorBusinessId = function () {
    return !_.isEmpty($scope.sponsor.businessId);
  };
  $scope.hasSelectedSponsor = function () {
    return !_.isEmpty($scope.sponsor.selected);
  };
  $scope.setSponsor = function () {
    if ($scope.hasSelectedSponsor()) {
      $scope.leg.flightSponsor = $scope.sponsor;
      $scope.hideSponsor();
      $scope.resetSummaryMessage();
      $scope.model.isNextDisabled = false;
    }
  };
  $scope.$watch('sponsor.sourceBusinessId', function () {
    if (_.isEmpty($scope.sponsor.sourceBusinessId)) {
      setDefaults();
    }
  });
  $scope.$watch('sponsor.businessId', function () {
    if (!_.isEmpty($scope.sponsor.businessId)) {
      $scope.collapse();
    }
  });
  $scope.$watch('sponsor.selected', function (newVal, oldVal) {
    if (newVal && oldVal && newVal.id !== oldVal.id) {
      $scope.sponsor.businessId = '';
    }
  });
  $scope.isContentAvailable = false;
  $scope.$on('sponsor-forecast-flight', function (e, data) {
    $scope.isContentAvailable = data || $scope.isAlreadySponsored();
  });
};
SponsorshipFlightPanelController.$inject = ['$scope', 'ConfigurationService'];
module.exports = SponsorshipFlightPanelController;